import React from 'react';
import { motion } from 'framer-motion';
import { MessageCircleIcon } from 'lucide-react';
import { WA_URL } from './constants';
export function FinalCTA() {
  return <section className="py-24 bg-navy relative overflow-hidden" data-id="element-26">
      {/* Decorative background elements */}
      <div className="absolute top-0 left-0 w-full h-full overflow-hidden z-0" data-id="element-27">
        <div className="absolute -top-24 -right-24 w-96 h-96 bg-orange rounded-full opacity-10 blur-3xl" data-id="element-28"></div>
        <div className="absolute -bottom-24 -left-24 w-96 h-96 bg-white rounded-full opacity-5 blur-3xl" data-id="element-29"></div>
      </div>

      <div className="container mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-30">
        <div className="max-w-3xl mx-auto text-center" data-id="element-31">
          <motion.h2 initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5
        }} className="text-3xl md:text-5xl font-bold text-white mb-6 leading-tight" data-id="element-32">
            ¿Tienes un proyecto de construcción o remodelación?
          </motion.h2>
          <motion.p initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: 0.1
        }} className="text-xl text-gray-300 mb-10" data-id="element-33">
            Escríbenos por WhatsApp y solicita tu presupuesto gratis. Te
            orientamos con claridad para avanzar con mayor confianza.
          </motion.p>
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: 0.2
        }} data-id="element-34">
            <a href={WA_URL} target="_blank" rel="noopener noreferrer" className="inline-flex items-center justify-center gap-2 bg-orange hover:bg-orange-hover text-white px-8 py-4 rounded-lg font-semibold text-lg transition-all duration-300 shadow-lg shadow-orange/25 hover:scale-105" data-id="element-35">
              <MessageCircleIcon className="w-6 h-6" data-id="element-36" />
              Solicitar presupuesto gratis
            </a>
          </motion.div>
        </div>
      </div>
    </section>;
}